module.exports = __webpack_public_path__ + "img/mingxi.28cb1765.png";